import type { TenantConfig } from '@/types/TenantConfig'

export const nga: TenantConfig = {
  logo: 'assets/nga/static/logo.svg',
  themeOptions: {
    dialog: {
      headerTextColor: '#fff',
      headerBackground: '#000',
      headerIconColor: '#fff',
    },
    mobileFooter: {
      backgroundColor: '#000',
      textColor: '#fff',
      priceTextColor: '#eee',
      cartButtonBackgroundColor: 'transparent',
      cartButtonHoverBackgroundColor: 'transparent',
      cartButtonBorder: '2px solid #ffffff',
      cartButtonIconColor: '#ffffff',
    },
  },
  svgIconOverrides: {
    PencilIcon: `
      <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M8.37384 2.69141H2.80763C2.38584 2.69141 1.98133 2.85941 1.68309 3.15846C1.38484 3.45751 1.21729 3.86311 1.21729 4.28603V15.4484C1.21729 15.8713 1.38484 16.2769 1.68309 16.576C1.98133 16.875 2.38584 17.0431 2.80763 17.0431H13.94C14.3618 17.0431 14.7663 16.875 15.0646 16.576C15.3628 16.2769 15.5304 15.8713 15.5304 15.4484V9.86723"
          fill="none"
          stroke="inherit"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M14.3377 1.49539C14.654 1.1782 15.083 1 15.5304 1C15.9778 1 16.4068 1.1782 16.7232 1.49539C17.0395 1.81258 17.2172 2.24278 17.2172 2.69136C17.2172 3.13993 17.0395 3.57014 16.7232 3.88733L9.16899 11.4618L5.98828 12.2591L6.78346 9.06987L14.3377 1.49539Z"
          fill="none"
          stroke="inherit"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    `,
  },
  i18nOverrides: {
    en: {
      cartWidget: {
        title: 'Reservation Summary',
        emptyCartMessage: 'You have no passes in your reservation.',
      },
      payButton: {
        desktop: {
          proceedButtonLabel: 'Complete Reservation',
          completeButtonLabel: 'Complete Reservation',
        },
      },
      checkoutRoute: {
        title: 'Complete Your Reservation',
      },
      reserve: {
        title: '1. Select passes',
        unavailable: 'Unfortunately, there are no more passes available for this event.',
        buttonLabel: {
          tickets: 'Add 1 Pass to Reservation | Add {count} Passes to Reservation',
        },
        ticketQuantity: '1 pass | {count} passes',
      },
      termsCheckbox: {
        checkboxLabel:
          'I agree to abide by the National Gallery of Art’s revised visitor policies for health and safety (required to complete reservation)',
      },
      stepperGroupTitles: {
        default: '',
      },
      reserveQuantityFirst: {
        findAvailableTickets: 'Find Available Passes',
      },
      conflictTimes: 'These times conflict with your other passes:',
      dateFormat: {
        long: 'dddd, MMMM D, YYYY',
      },
      admitDetailsFields: {
        title: 'Enter each visitorʼs name below (required)',
      },
      completedOrdersRoute: {
        ticketsOrderNumber: 'Your Reservation Number is {number}',
      },
      resendOrderRoute: {
        title: 'Enter your email address to resend your passes',
        notFound: 'No reservations could be found for this email address.',
        logout: 'Log out to resend your passes.',
        buttonLabel: 'Resend Reservation Email',
        completeTitle: 'Your reservation confirmation and passes have been resent.',
      },
      cancelFreeOrderRoute: {
        cancelTicketsTitle: 'Cancel Reservation',
        cancelTicketsSubtext:
          'To cancel individual passes, select the checkbox next to the passes you would like to cancel and click “Cancel Selected Passes.” Need to cancel your entire reservation? Click “Cancel Reservation.” You will receive an email confirming your cancellation(s). Need additional help? Email tickets@nga.gov or call (202) 842-6997.',
        ticketName: '{typeName} pass {index}',
        noTicketsFound: 'No valid passes found on this reservation.',
        noFreeTicketsFound: 'You must contact us to cancel this reservation.',
        selectAllLabel: 'Select all passes',
        cancelSelectedLabel: 'Cancel Selected Passes',
        cancelOrderLabel: 'Cancel Reservation',
        order: 'Reservation',
        cancelModalTitle: 'Cancel Passes',
        cancelModalSubtext:
          'Are you sure you want to cancel 1 pass from your reservation? | Are you sure you want to cancel {count} passes from your reservation?',
        orderCancelled: 'You have successfully cancelled your reservation',
        ticketsCancelled: 'You have successfully cancelled 1 pass | You have successfully cancelled {count} passes',
      },
    },
  },
  customContent: [
    {
      key: 'before-footer',
      regions: ['before-footer'],
    },
  ],
}
